// extracted by mini-css-extract-plugin
module.exports = {"reelBtn":"reel-footer_reelBtn__ER45L"};